import { CssType, ThemeType } from '@theming/jssTypes';

export const styles = (theme: ThemeType): CssType => ({
  tableContainer: {
    boxSizing: 'border-box',
    backgroundColor: theme.color.semantic.background.neutral.secondary,
    borderRadius: theme.radius.md,
    margin: '1% 0.5%',
    border: theme.border.width[0],

    flex: '1 1 0',
    overflow: 'auto',
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
      padding: theme.spacing[3],
    },
  },
  timeline: {
    backgroundColor: theme.color.semantic.background.neutral.secondary,
    position: 'relative',
    padding: '1.5% 0 0 10%',
    border: theme.border.width[0],
    width: '100%',
  },
  eventTime: {
    fontFamily: theme.typography.fontFamily.primary,
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeight.medium,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.normal,
    color: theme.color.semantic.text.secondary,
  },
  eventName: {
    fontFamily: theme.typography.fontFamily.primary,
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeight.regular,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.normal,
  },
  eventDetailsBlock: {
    width: '100%',
    borderRadius: theme.radius.md,
  },
  eventDetailsColumn: {
    paddingBottom: '1%',
    '& .ant-collapse > .ant-collapse-item > .ant-collapse-header': {
      padding: `${theme.spacing[3]} ${theme.spacing[4]} ${theme.spacing[0]} ${theme.spacing[4]}`,
    },
  },
  content: {
    fontSize: theme.typography.fontSize.md,
    color: theme.color.semantic.text.primary,
    fontWeight: theme.typography.fontWeight.medium,
    wordBreak: 'break-word',
    textTransform: 'capitalize',
  },
  column: {
    margin: `${theme.spacing[3]} ${theme.spacing[0]}`,
  },
  hintHeader: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.color.semantic.text.secondary,
    fontWeight: theme.typography.fontWeight.regular,
    margin: `${theme.spacing[3]} ${theme.spacing[0]} ${theme.spacing[3]} ${theme.spacing[0]}`,
  },
  expandBtn: {
    textAlign: 'right',
    paddingRight: '7.5%',
  },
  btn: {
    color: theme.color.semantic.brand.default.primary,
    cursor: 'default',
  },
  toggleDetails: {
    margin: `${theme.spacing[0]} ${theme.spacing[0]} ${theme.spacing[0]} 0.25rem`,
  },
  timelineEvent: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'left',
  },
  timelineEventHeader: {
    color: theme.color.semantic.text.secondary,
    width: '50%',
  },
  textIndent1dot7: {
    textIndent: '1.7em',
  },
  textIndent1dot8: {
    textIndent: '1.8em',
  },
  textIndent6: {
    textIndent: '6em',
  },
  textIndent8: {
    textIndent: '8em',
  },
  textIndent11: {
    textIndent: '11em',
  },
  textIndent12: {
    textIndent: '12em',
  },
  activeLink: {
    color: theme.color.semantic.brand.default.primary,
  },
  dark45: {
    color: theme.color.semantic.text.secondary,
  },
  dark85: {
    color: theme.color.semantic.text.primary,
  },
  customCollapseHeader: {
    border: 'none !important',
    padding: `${theme.spacing[0]} ${theme.spacing[0]} ${theme.spacing[0]} ${theme.spacing[0]}`,
  }
});
